import {checkCookies, getCookie, setCookie, getBrowser, getURLParameterByName} from "./utilities";

const cookieName = 'kies_ad_et';
export const initialAdsCookie = {
    gclid: '',
    fbclid: '',
    msclkid: '',
    source_first: 'unknown',
    source_last: 'unknown',
    suchumfeld_first: 'unknown',
    suchumfeld_last: 'unknown',
    keyword_first: 'unknown',
    keyword_last: 'unknown',
    studio_first: 'unknown',
    studio_last: 'unknown',
    matchtype_first: 'unknown',
    matchtype_last: 'unknown',
    network_first: 'unknown',
    network_last: 'unknown',
    placement: 'unknown',
    device: 'unknown',
    browser: 'unknown',
    consent: 'unknown',
    adgroup_id: ''
};

export default class KiesAdEt {
    constructor () {
        this.cookieObj = initialAdsCookie;
        this.init();
    }

    init () {
        if(getCookie(cookieName) !== '') {
            if(!!decodeURIComponent(getCookie(cookieName))) {
                this.cookieObj = JSON.parse(decodeURIComponent(getCookie(cookieName)));
            }
        }

        if(document.referrer.indexOf(window.location.host) < 0) {
            this.setGClid();
            this.setFBClid();
            this.setMsclkid();
            this.setSource();
            this.setSuchumfeld();
            this.setKeyword();
            this.setStudioUid();
            this.setMatchtype();
            this.setNetwork();
            this.setPlacement();
            this.setDevice();
            this.setBrowser();
            this.setConsent();
            this.setAdgroupId();
        }

        setCookie(cookieName, encodeURIComponent(JSON.stringify(this.cookieObj)), 30);
    }

    setGClid () {
        if(!!this.cookieObj.gclid || this.cookieObj.gclid === '') {
            this.cookieObj.gclid = getURLParameterByName('gclid', window.location.href) === null ? '' : getURLParameterByName('gclid', window.location.href);
        }
    }

    setFBClid () {
        if(!!this.cookieObj.fbclid || this.cookieObj.fbclid === '') {

            if(getURLParameterByName('fbclid', window.location.href) === null) {

                if(getURLParameterByName('utm_source', window.location.href) === 'facebook.com' && getURLParameterByName('utm_medium', window.location.href) === 'Ads') {
                    this.cookieObj.fbclid = 'Facebook Ads';
                } else {
                    this.cookieObj.fbclid = '';
                }
            } else {
                this.cookieObj.fbclid = getURLParameterByName('fbclid', window.location.href);
            }
        }
    }

    setMsclkid () {
        if(!!this.cookieObj.msclkid || this.cookieObj.msclkid === '') {

            if(getURLParameterByName('msclkid', window.location.href) === null) {

                if(getURLParameterByName('utm_source', window.location.href) === 'bing' && getURLParameterByName('utm_medium', window.location.href) === 'cpc') {
                    this.cookieObj.msclkid = 'Bing Ads';
                } else {
                    this.cookieObj.msclkid = '';
                }
            } else {
                this.cookieObj.msclkid = getURLParameterByName('msclkid', window.location.href);
            }
        }
    }

    setSource () {
        if(!!this.cookieObj.source_first || this.cookieObj.source_first === '') {
            if (getURLParameterByName('gclid', window.location.href) !== null) {
                this.cookieObj.source_first = 'Google Ads';
                this.cookieObj.source_last = 'Google Ads';
            } else if (getURLParameterByName('fbclid', window.location.href) !== null || (getURLParameterByName('utm_source', window.location.href) === 'facebook.com' && getURLParameterByName('utm_medium', window.location.href) === 'Ads')) {
                this.cookieObj.source_first = 'Facebook Ads';
                this.cookieObj.source_last = 'Facebook Ads';
            } else if (getURLParameterByName('utm_source', window.location.href) !== null) {
                if(getURLParameterByName('utm_source', window.location.href) === 'facebook.com' && getURLParameterByName('utm_medium', window.location.href) === 'Ads') {
                    this.cookieObj.source_first = 'Facebook Ads';
                    this.cookieObj.source_last = 'Facebook Ads';
                } else {
                    this.cookieObj.source_first = getURLParameterByName('utm_medium', window.location.href) !== null ? getURLParameterByName('utm_source', window.location.href) + ' ' + getURLParameterByName('utm_medium', window.location.href) : getURLParameterByName('utm_source', window.location.href);
                    this.cookieObj.source_last = getURLParameterByName('utm_medium', window.location.href) !== null ? getURLParameterByName('utm_source', window.location.href) + ' ' + getURLParameterByName('utm_medium', window.location.href) : getURLParameterByName('utm_source', window.location.href);
                }
            } else {
                this.cookieObj.source_first = 'unknown';
                this.cookieObj.source_last = 'unknown';
            }
        } else {
            if (getURLParameterByName('gclid', window.location.href) !== null) {
                this.cookieObj.source_last = 'Google Ads';
            } else if(getURLParameterByName('fbclid', window.location.href) !== null) {
                this.cookieObj.source_last = 'Facebook Ads';
            } else if (getURLParameterByName('utm_source', window.location.href) !== null) {
                if(getURLParameterByName('utm_source', window.location.href) === 'facebook.com' && getURLParameterByName('utm_medium', window.location.href) === 'Ads') {
                    this.cookieObj.source_last = 'Facebook Ads';
                } else {
                    this.cookieObj.source_last = getURLParameterByName('utm_medium', window.location.href) !== null ? getURLParameterByName('utm_source', window.location.href) + ' ' + getURLParameterByName('utm_medium', window.location.href) : getURLParameterByName('utm_source', window.location.href);
                }
            } else {
                this.cookieObj.source_last = 'unknown';
            }
        }
    }

    setSuchumfeld () {
        if(!!this.cookieObj.suchumfeld_first || this.cookieObj.suchumfeld_first === '') {
            this.cookieObj.suchumfeld_first = getURLParameterByName('suchumfeld', window.location.href) === null ? 'unknown' : getURLParameterByName('suchumfeld', window.location.href);
            this.cookieObj.suchumfeld_last = getURLParameterByName('suchumfeld', window.location.href) === null ? 'unknown' : getURLParameterByName('suchumfeld', window.location.href);
        } else {
            this.cookieObj.suchumfeld_last = getURLParameterByName('suchumfeld', window.location.href) === null ? 'unknown' : getURLParameterByName('suchumfeld', window.location.href);
        }
    }

    setKeyword () {
        if(!!this.cookieObj.keyword_first || this.cookieObj.keyword_first === '') {
            this.cookieObj.keyword_first = getURLParameterByName('keyword', window.location.href) === null ? 'unknown' : getURLParameterByName('keyword', window.location.href);
            this.cookieObj.keyword_last = getURLParameterByName('keyword', window.location.href) === null ? 'unknown' : getURLParameterByName('keyword', window.location.href);
        } else {
            this.cookieObj.keyword_last = getURLParameterByName('keyword', window.location.href) === null ? 'unknown' : getURLParameterByName('keyword', window.location.href);
        }
    }

    setStudioUid () {
        let urlParams = window.location.pathname.split('/');

        if(urlParams.indexOf('_studio') > - 1) {
            let studioUid = urlParams[urlParams.indexOf('_studio') + 1];

            if(!!this.cookieObj.studio_first || this.cookieObj.studio_first === '') {
                this.cookieObj.studio_first = studioUid;
                this.cookieObj.studio_last = studioUid;
            } else {
                this.cookieObj.studio_last = studioUid;
            }
        } else {
            if(!!this.cookieObj.studio_first || this.cookieObj.studio_first === '') {
                this.cookieObj.studio_first = 'unknown';
            }

            this.cookieObj.studio_last = 'unknown';
        }
    }

    setMatchtype () {
        if(!!this.cookieObj.matchtype_first || this.cookieObj.matchtype_first === '') {
            this.cookieObj.matchtype_first = getURLParameterByName('matchtype', window.location.href) === null ? 'unknown' : getURLParameterByName('matchtype', window.location.href);
            this.cookieObj.matchtype_last = getURLParameterByName('matchtype', window.location.href) === null ? 'unknown' : getURLParameterByName('matchtype', window.location.href);
        } else {
            this.cookieObj.matchtype_last = getURLParameterByName('matchtype', window.location.href) === null ? 'unknown' : getURLParameterByName('matchtype', window.location.href);
        }
    }

    setNetwork () {
        if(!!this.cookieObj.network_first || this.cookieObj.network_first === '') {
            this.cookieObj.network_first = getURLParameterByName('network', window.location.href) === null ? 'unknown' : getURLParameterByName('network', window.location.href);
            this.cookieObj.network_last = getURLParameterByName('network', window.location.href) === null ? 'unknown' : getURLParameterByName('network', window.location.href);
        } else {
            this.cookieObj.network_last = getURLParameterByName('network', window.location.href) === null ? 'unknown' : getURLParameterByName('network', window.location.href);
        }
    }

    setPlacement () {
        this.cookieObj.placement = getURLParameterByName('placement', window.location.href) === null ? 'unknown' : getURLParameterByName('placement', window.location.href);
    }

    setDevice () {
        this.cookieObj.device = getURLParameterByName('device', window.location.href) === null ? 'unknown' : getURLParameterByName('device', window.location.href);
    }

    setBrowser () {
        this.cookieObj.browser = getBrowser();
    }

    setConsent () {
        if(checkCookies()) {
            this.cookieObj.consent = window.uc_kies_ad_et ? 'accepted' : 'declined';
        } else {
            this.cookieObj.consent = 'browser rejects cookies';
        }
    }

    setAdgroupId () {
        if(!!this.cookieObj.adgroup_id || this.cookieObj.adgroup_id === '') {
            this.cookieObj.adgroup_id = getURLParameterByName('adgroupid', window.location.href) === null ? '' : getURLParameterByName('adgroupid', window.location.href);
        }
    }
}
